module.exports = __webpack_public_path__ + "assets/img/arrowRight.bbe3edfb.svg";